import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth-card" }
const _hoisted_2 = { class: "auth-header" }
const _hoisted_3 = { class: "auth-tabs" }
const _hoisted_4 = { class: "auth-label" }
const _hoisted_5 = { class: "auth-label" }
const _hoisted_6 = { class: "auth-label" }
const _hoisted_7 = { class: "auth-optional" }
const _hoisted_8 = { class: "auth-label" }
const _hoisted_9 = { class: "auth-label" }
const _hoisted_10 = { class: "auth-check" }
const _hoisted_11 = {
  key: 0,
  class: "auth-error"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "auth-label" }
const _hoisted_14 = { class: "auth-label" }
const _hoisted_15 = {
  key: 0,
  class: "auth-error"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "auth-disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "popup-fade" }, {
    default: _withCtx(() => [
      (_ctx.getAuthModalVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "auth-overlay",
            onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: _normalizeClass(['auth-tab', { 'auth-tab--active': _ctx.mode === 'register' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mode = 'register'))
                  }, _toDisplayString(_ctx.jsonData.authRegisterTab), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(['auth-tab', { 'auth-tab--active': _ctx.mode === 'login' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'login'))
                  }, _toDisplayString(_ctx.jsonData.authLoginTab), 3)
                ]),
                _createElementVNode("button", {
                  class: "auth-close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, "×")
              ]),
              (_ctx.mode === 'register')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    class: "auth-form",
                    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRegister && _ctx.submitRegister(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("label", _hoisted_4, [
                      _createTextVNode(_toDisplayString(_ctx.jsonData.authFullName) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "auth-input",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerForm.fullName) = $event)),
                        type: "text",
                        autocomplete: "name",
                        required: "",
                        minlength: "2",
                        maxlength: "60"
                      }, null, 512), [
                        [_vModelText, _ctx.registerForm.fullName]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.jsonData.authEmail) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "auth-input",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerForm.email) = $event)),
                        type: "email",
                        inputmode: "email",
                        autocomplete: "email",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.registerForm.email]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_ctx.jsonData.authPhone) + " ", 1),
                      _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(_ctx.jsonData.authOptional) + ")", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "auth-input",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerForm.phone) = $event)),
                        type: "tel",
                        inputmode: "tel",
                        autocomplete: "tel"
                      }, null, 512), [
                        [_vModelText, _ctx.registerForm.phone]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.jsonData.authPassword) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "auth-input",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerForm.password) = $event)),
                        type: "password",
                        autocomplete: "new-password",
                        required: "",
                        minlength: "6"
                      }, null, 512), [
                        [_vModelText, _ctx.registerForm.password]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.jsonData.authConfirmPassword) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "auth-input",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerForm.confirmPassword) = $event)),
                        type: "password",
                        autocomplete: "new-password",
                        required: "",
                        minlength: "6"
                      }, null, 512), [
                        [_vModelText, _ctx.registerForm.confirmPassword]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registerForm.agreeTerms) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.registerForm.agreeTerms]
                      ]),
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.jsonData.authAgreePrefix) + " ", 1),
                        _createVNode(_component_router_link, {
                          to: "/terms",
                          onClick: _ctx.close
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.jsonData.authAgreeLink), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.jsonData.authAgreeSuffix), 1)
                      ])
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.error), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "auth-submit",
                      type: "submit",
                      disabled: _ctx.submitting
                    }, _toDisplayString(_ctx.jsonData.authRegisterSubmit), 9, _hoisted_12)
                  ], 32))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    class: "auth-form",
                    onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("label", _hoisted_13, [
                      _createTextVNode(_toDisplayString(_ctx.jsonData.authEmail) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "auth-input",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.loginForm.email) = $event)),
                        type: "email",
                        inputmode: "email",
                        autocomplete: "email",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.loginForm.email]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.jsonData.authPassword) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: "auth-input",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                        type: "password",
                        autocomplete: "current-password",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.loginForm.password]
                      ])
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.error), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "auth-submit",
                      type: "submit",
                      disabled: _ctx.submitting
                    }, _toDisplayString(_ctx.jsonData.authLoginSubmit), 9, _hoisted_16)
                  ], 32)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.jsonData.authDisclaimer), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}